import React, { useMemo, useState } from "react";
import { useDesktopKeyboardContext } from "../context/DesktopKeyboardContext";
import { universalSearchService } from "../search/UniversalSearchService";

interface UniversalSearchProps {
  open: boolean;
  onClose: () => void;
}

export default function UniversalSearch({ open, onClose }: UniversalSearchProps) {
  const { commandBus } = useDesktopKeyboardContext();
  const [query, setQuery] = useState("");

  const results = useMemo(() => universalSearchService.search(query), [query]);

  if (!open) return null;

  return (
    <div className="desktop-overlay" role="dialog" aria-modal="true">
      <div className="desktop-panel">
        <input
          autoFocus
          className="desktop-input"
          placeholder="Search customers, products, invoices, barcodes..."
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape") onClose();
          }}
        />
        <ul className="desktop-list">
          {results.map((result) => (
            <li key={result.id}>
              <button
                className="desktop-list-item"
                onClick={() => {
                  commandBus.execute(result.commandId, result.payload, { source: "search" });
                  onClose();
                }}
              >
                <span>{result.label}</span>
                <code>{result.type}</code>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
